import { provideBrightnavPlugin } from './brightnav.plugin';

export const BrightnavModule = [
  provideBrightnavPlugin(),
];
